import React, { FunctionComponent } from 'react';

// types
import { DefaultBrandingSet } from 'ducks/merchantDucks/branding/types';

// components
import BrandHeader from './PaywallElements/BrandHeader';
import Header from './PaywallElements/Header';
import Footer from './PaywallElements/Footer';
import { PaywallContainer, SectionContainer, FormContainer, StyledInput, ButtonHolder, Button } from './StyledElements';

interface Props {
  branding: DefaultBrandingSet;
}

const CodeAccessScreen: FunctionComponent<Props> = ({ branding }) => {
  const {
    paywall_secondary_color: paywallSecondaryColor,
    paywall_brand_logo: paywallBrandLogo,
    paywall_primary_color: paywallPrimaryColor,
    paywall_buttons_bg_color: paywallButtonsBgColor,
  } = branding;

  return (
    <PaywallContainer>
      <BrandHeader backgroundColor={paywallSecondaryColor} brandLogo={paywallBrandLogo} />
      <Header borderColor={paywallPrimaryColor} title="ENTER YOUR ACCESS CODE" />
      <SectionContainer>
        <FormContainer>
          <StyledInput type="text" placeholder="Code" readOnly />
          <ButtonHolder>
            <Button buttonBgColor={paywallButtonsBgColor}>Apply</Button>
          </ButtonHolder>
        </FormContainer>
      </SectionContainer>
      <Footer backgroundColor={paywallPrimaryColor} />
    </PaywallContainer>
  );
};

export default CodeAccessScreen;
